import { Box, Typography, useTheme } from '@mui/material';
import { parseISO, format } from 'date-fns';

type Props = {
  timestamp?: string | null;
};

export const LastUpdatedBox = ({ timestamp }: Props) => {
  const theme = useTheme();

  const formattedDate = (() => {
    if (!timestamp) return '-';

    try {
      const isZoned = /[zZ]|([+-]\d{2}:\d{2})$/.test(timestamp);
      const correctedTimestamp = isZoned ? timestamp : `${timestamp}Z`;

      const date = parseISO(correctedTimestamp);

      return format(date, 'M/dd/yy hh:mma').toLowerCase();
    } catch {
      return '-';
    }
  })();

  return (
    <Box>
      <Typography sx={{ color: theme.palette.grey[700], fontSize: '15px' }}>
        Updated: {formattedDate}
      </Typography>
    </Box>
  );
};
